import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react/jsx-pascal-case */

/* eslint-disable camelcase */
import React, { useState, useContext } from 'react';
import { ThemeProvider, ThemeContext } from 'styled-components';
import { getSearchPath } from '@sainsburys-tech/boltui-utils';
import { Image, Deprecated_SearchBar } from '@sainsburys-tech/bolt';
import { MenuIcon, StoreIcon, InfoIcon, TrolleyIcon, AccountIcon, WishlistIcon } from '@sainsburys-tech/bolt-icons';
import * as Styled from './Fallback.styles';
var logoUrl = 'https://media.4rgos.it/i/Argos/logo_argos2x';
var homePageUrl = '/';

var TopBar = function TopBar() {
  return /*#__PURE__*/React.createElement(Styled.TopBar, null, /*#__PURE__*/React.createElement(Styled.TopLink, {
    href: "/stores/"
  }, /*#__PURE__*/React.createElement(StoreIcon, null), /*#__PURE__*/React.createElement("span", null, "Stores")), /*#__PURE__*/React.createElement(Styled.TopLink, {
    href: "/help/"
  }, /*#__PURE__*/React.createElement(InfoIcon, null), /*#__PURE__*/React.createElement("span", null, "Help")));
};

var Logo = function Logo() {
  return /*#__PURE__*/React.createElement(Styled.LogoContainer, null, /*#__PURE__*/React.createElement(Styled.LogoLink, {
    href: homePageUrl
  }, /*#__PURE__*/React.createElement(Image, {
    width: 120,
    height: 103,
    src: logoUrl,
    fallbackFmt: "fmt=png",
    alt: "Argos Logo - Load homepage"
  })));
}; // A no-frills fallback - has no logged in state, no meganav, no autosuggest, no
// trolley counts, no analytics, no SPA routing etc. Will rarely be seen by users.


var Fallback = function Fallback() {
  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      searchTerm = _useState2[0],
      setSearchTerm = _useState2[1];

  var currentTheme = useContext(ThemeContext); // Header search bar is grey

  var greyscaleTheme = _objectSpread(_objectSpread({}, currentTheme), {}, {
    color_grey_mid: currentTheme.color.monochrome.dark,
    color_secondary: currentTheme.color.monochrome.dark,
    color_secondary_dark: currentTheme.color.monochrome.darker
  });

  var onSearch = function onSearch() {
    if (searchTerm.trim()) {
      window.location.href = "".concat(getSearchPath(searchTerm));
    }
  };

  return /*#__PURE__*/React.createElement(Styled.Header, null, /*#__PURE__*/React.createElement(TopBar, null), /*#__PURE__*/React.createElement(Styled.Main, null, /*#__PURE__*/React.createElement(Logo, null), /*#__PURE__*/React.createElement(Styled.ShopLink, {
    href: homePageUrl
  }, "Shop"), /*#__PURE__*/React.createElement(Styled.Search, null, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: greyscaleTheme
  }, /*#__PURE__*/React.createElement(Deprecated_SearchBar, {
    value: searchTerm,
    placeholder: "Search products, brands or FAQs",
    onChange: function onChange(evt) {
      return setSearchTerm(evt.target.value);
    },
    onSubmit: onSearch
  }))), /*#__PURE__*/React.createElement(Styled.Icons, null, /*#__PURE__*/React.createElement(Styled.IconLink, {
    href: homePageUrl,
    className: "md-hidden"
  }, /*#__PURE__*/React.createElement(MenuIcon, null), /*#__PURE__*/React.createElement("span", null, "Shop")), /*#__PURE__*/React.createElement(Styled.IconLink, {
    href: "/account/login"
  }, /*#__PURE__*/React.createElement(AccountIcon, null), /*#__PURE__*/React.createElement("span", null, "Account")), /*#__PURE__*/React.createElement(Styled.IconLink, {
    href: "/wishlist"
  }, /*#__PURE__*/React.createElement(WishlistIcon, null), /*#__PURE__*/React.createElement("span", null, "Wishlist")), /*#__PURE__*/React.createElement(Styled.IconLink, {
    href: "/basket"
  }, /*#__PURE__*/React.createElement(TrolleyIcon, null), /*#__PURE__*/React.createElement("span", null, "Trolley")))));
};

export default Fallback;